module.exports = __webpack_public_path__ + "img/features_icon_2.18b8d79a.svg";